export function taxCalculation(price: string, taxRate: string) {
  const taxRateCalc = (taxRate: string) => {
    const taxRateTemp = taxRate.replace(/[&\\#,+()$~%'":*?<>{}]/g, '');
    return parseFloat(taxRateTemp) * 0.001;
  };
  let tempPrice = price && price.replace(/[&\\#,+()$~%'":*?<>{}]/g, '');
  let taxAmount = parseFloat(tempPrice) * taxRateCalc(taxRate);
  return addComma(taxAmount.toFixed(2));
}
export const addComma = (num: any) => {
  if (num === null) return;
  const num_T = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return num_T;
};
